import { render, staticRenderFns } from "./comnonniketh.vue?vue&type=template&id=8422b474&"
import script from "./comnonniketh.vue?vue&type=script&lang=js&"
export * from "./comnonniketh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QImg,QCardSection} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QImg,QCardSection}, component.options.components || {})
